<div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
        <div class="modal-header">
            @if (selectedForm) {
                <h4 class="modal-title">{{selectedForm.name}}</h4>
            }
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span>&times;</span>
            </button>
        </div>
        <div class="modal-body text-dark">
            @if (dynamicForm && dynamicForm.enabled) {
                <form [formGroup]="dynamicForm">
                    <div class="row">
                        @for (control of setupValues; track control; let i = $index) {
                            <div class="form-group col-md-6 col-sm-12" [ngClass]="{'form-check d-flex' : control.type == 'checkbox'}">
                                @if (control.type != 'contact') {
                                    <label [ngClass]="{'form-check-label' : control.type == 'checkbox'}">{{control.label}}</label>
                                }
                                @if (control.type != 'checkbox' && control.type != 'contact') {
                                    <input [type]="control.type" [name]="i" [formControlName]="control.name" class="form-control" (change)="updateValue($event)">
                                }
                                @if (control.type == 'checkbox') {
                                    <input [type]="control.type" [checked]="control.value" [name]="i" [formControlName]="control.name" class="form-check-input" (change)="updateValue($event)">
                                }
                                @if (control.type == 'contact') {
                                    <contact-advanced-search type="warranty" (setContactId)="setContactIdEvent($event)" [contactIdSaved]="control.value" (change)="updateValue($event)"></contact-advanced-search>
                                }
                            </div>
                        }
                    </div>
                </form>
            }
            @if (privacyNoticeForm && privacyNoticeForm.enabled) {
            <form [formGroup]="privacyNoticeForm">
                <section>
                    <h5>What information will you be collecting? (Please give 6 examples)</h5>
                    <div class="row">
                        <div class="col-md-6">
                            <input class="form-control form-control-sm" formControlName="whatInformationCollected1" name="whatInformationCollected1" (change)="updatePrivacyNoticeValue($event)">
                            <input class="form-control form-control-sm" formControlName="whatInformationCollected2" name="whatInformationCollected2" (change)="updatePrivacyNoticeValue($event)">
                            <input class="form-control form-control-sm" formControlName="whatInformationCollected3" name="whatInformationCollected3" (change)="updatePrivacyNoticeValue($event)">
                        </div>
                        <div class="col-md-6">
                            <input class="form-control form-control-sm" formControlName="whatInformationCollected4" name="whatInformationCollected4" (change)="updatePrivacyNoticeValue($event)">
                            <input class="form-control form-control-sm" formControlName="whatInformationCollected5" name="whatInformationCollected5" (change)="updatePrivacyNoticeValue($event)">
                            <input class="form-control form-control-sm" formControlName="whatInformationCollected6" name="whatInformationCollected6" (change)="updatePrivacyNoticeValue($event)">
                        </div>
                    </div>
                </section>
                <section>
                    <h5>Reasons you can share customer information</h5>
                    <dl class="row mb-0">
                        <dt class="col-sm-5">For our every day business purposes</dt>
                        <dd class="col-sm-2">
                            <div class="form-check form-check-inline">
                                <input type="radio" id="reasons1" name="reasons1" class="form-check-input" formControlName="reasons1" (change)="updatePrivacyNoticeValue($event)" name="reasons1" value="Yes">
                                <label class="form-check-label" for="reasons1">Yes</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="radio" id="reasons1" name="reasons1" class="form-check-input" formControlName="reasons1" (change)="updatePrivacyNoticeValue($event)" value="No">
                                <label class="form-check-label" for="reasons1">No</label>
                            </div>
                        </dd>
                        <dd class="col-sm-2 text-nowrap">Can customers limit this?</dd>
                        <dd class="col-sm-3">
                            <div class="form-check form-check-inline">
                                <input type="radio" id="customerLimit1" name="customerLimit1" class="form-check-input" formControlName="customerLimit1" (change)="updatePrivacyNoticeValue($event)" value="Yes">
                                <label class="form-check-label" for="customerLimit1">Yes</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="radio" id="customerLimit1" name="customerLimit1" class="form-check-input" formControlName="customerLimit1" (change)="updatePrivacyNoticeValue($event)" value="No">
                                <label class="form-check-label" for="customerLimit1">No</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="radio" id="customerLimit1" name="customerLimit1" class="form-check-input" formControlName="customerLimit1" (change)="updatePrivacyNoticeValue($event)" value="We don't share">
                                <label class="form-check-label" for="customerLimit1">We don't share</label>
                            </div>
                        </dd>
                    </dl>
                    <dl class="row mb-0">
                        <dt class="col-sm-5">For our marking purposes</dt>
                        <dd class="col-sm-2">
                            <div class="form-check form-check-inline">
                                <input type="radio" id="reasons2" name="reasons2" class="form-check-input" formControlName="reasons2" (change)="updatePrivacyNoticeValue($event)" value="Yes">
                                <label class="form-check-label" for="reasons2">Yes</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="radio" id="reasons2" name="reasons2" class="form-check-input" formControlName="reasons2" (change)="updatePrivacyNoticeValue($event)" value="No">
                                <label class="form-check-label" for="reasons2">No</label>
                            </div>
                        </dd>
                        <dd class="col-sm-2 text-nowrap">Can customers limit this?</dd>
                        <dd class="col-sm-3">
                            <div class="form-check form-check-inline">
                                <input type="radio" id="customerLimit2" name="customerLimit2" class="form-check-input" formControlName="customerLimit2" (change)="updatePrivacyNoticeValue($event)" value="Yes">
                                <label class="form-check-label" for="customerLimit1">Yes</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="radio" id="customerLimit2" name="customerLimit2" class="form-check-input" formControlName="customerLimit2" (change)="updatePrivacyNoticeValue($event)" value="No">
                                <label class="form-check-label" for="customerLimit2">No</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="radio" id="customerLimit2" name="customerLimit2" class="form-check-input" formControlName="customerLimit2" (change)="updatePrivacyNoticeValue($event)" value="We don't share">
                                <label class="form-check-label" for="customerLimit2">We don't share</label>
                            </div>
                        </dd>
                    </dl>
                    <dl class="row mb-0">
                        <dt class="col-sm-5">For joint marketing purposes with other companies</dt>
                        <dd class="col-sm-2">
                            <div class="form-check form-check-inline">
                                <input type="radio" id="reasons3" name="reasons3" class="form-check-input" formControlName="reasons3" (change)="updatePrivacyNoticeValue($event)" value="Yes">
                                <label class="form-check-label" for="reasons2">Yes</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="radio" id="reasons3" name="reasons3" class="form-check-input" formControlName="reasons3" (change)="updatePrivacyNoticeValue($event)" value="No">
                                <label class="form-check-label" for="reasons3">No</label>
                            </div>
                        </dd>
                        <dd class="col-sm-2 text-nowrap">Can customers limit this?</dd>
                        <dd class="col-sm-3">
                            <div class="form-check form-check-inline">
                                <input type="radio" id="customerLimit3" name="customerLimit3" class="form-check-input" formControlName="customerLimit3" (change)="updatePrivacyNoticeValue($event)" value="Yes">
                                <label class="form-check-label" for="customerLimit3">Yes</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="radio" id="customerLimit3" name="customerLimit3" class="form-check-input" formControlName="customerLimit3" (change)="updatePrivacyNoticeValue($event)" value="No">
                                <label class="form-check-label" for="customerLimit3">No</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="radio" id="customerLimit3" name="customerLimit3" class="form-check-input" formControlName="customerLimit3" (change)="updatePrivacyNoticeValue($event)" value="We don't share">
                                <label class="form-check-label" for="customerLimit3">We don't share</label>
                            </div>
                        </dd>
                    </dl>
                    <dl class="row mb-0">
                        <dt class="col-sm-5">For our affiliates every day business purposes - Transactions</dt>
                        <dd class="col-sm-2">
                            <div class="form-check form-check-inline">
                                <input type="radio" id="reasons4" name="reasons4" class="form-check-input" formControlName="reasons4" (change)="updatePrivacyNoticeValue($event)" value="Yes">
                                <label class="form-check-label" for="reasons4">Yes</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="radio" id="reasons4" name="reasons4" class="form-check-input" formControlName="reasons4" (change)="updatePrivacyNoticeValue($event)" value="No">
                                <label class="form-check-label" for="reasons4">No</label>
                            </div>
                        </dd>
                        <dd class="col-sm-2 text-nowrap">Can customers limit this?</dd>
                        <dd class="col-sm-3">
                            <div class="form-check form-check-inline">
                                <input type="radio" id="customerLimit4" name="customerLimit4" class="form-check-input" formControlName="customerLimit4" (change)="updatePrivacyNoticeValue($event)" value="Yes">
                                <label class="form-check-label" for="customerLimit4">Yes</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="radio" id="customerLimit4" name="customerLimit4" class="form-check-input" formControlName="customerLimit4" (change)="updatePrivacyNoticeValue($event)" value="No">
                                <label class="form-check-label" for="customerLimit4">No</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="radio" id="customerLimit4" name="customerLimit4" class="form-check-input" formControlName="customerLimit4" (change)="updatePrivacyNoticeValue($event)" value="We don't share">
                                <label class="form-check-label" for="customerLimit4">We don't share</label>
                            </div>
                        </dd>
                    </dl>
                    <dl class="row mb-0">
                        <dt class="col-sm-5">For our affiliates every day business purposes - Creditworthiness</dt>
                        <dd class="col-sm-2">
                            <div class="form-check form-check-inline">
                                <input type="radio" id="reasons5" name="reasons5" class="form-check-input" formControlName="reasons5" (change)="updatePrivacyNoticeValue($event)" value="Yes">
                                <label class="form-check-label" for="reasons5">Yes</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="radio" id="reasons5" name="reasons5" class="form-check-input" formControlName="reasons5" (change)="updatePrivacyNoticeValue($event)" value="No">
                                <label class="form-check-label" for="reasons5">No</label>
                            </div>
                        </dd>
                        <dd class="col-sm-2 text-nowrap">Can customers limit this?</dd>
                        <dd class="col-sm-3">
                            <div class="form-check form-check-inline">
                                <input type="radio" id="customerLimit5" name="customerLimit5" class="form-check-input" formControlName="customerLimit5" (change)="updatePrivacyNoticeValue($event)" value="Yes">
                                <label class="form-check-label" for="customerLimit5">Yes</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="radio" id="customerLimit5" name="customerLimit5" class="form-check-input" formControlName="customerLimit5" (change)="updatePrivacyNoticeValue($event)" value="No">
                                <label class="form-check-label" for="customerLimit5">No</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="radio" id="customerLimit5" name="customerLimit5" class="form-check-input" formControlName="customerLimit5" (change)="updatePrivacyNoticeValue($event)" value="We don't share">
                                <label class="form-check-label" for="customerLimit5">We don't share</label>
                            </div>
                        </dd>
                    </dl>
                    <dl class="row mb-0">
                        <dt class="col-sm-5">For our affiliates to market to you</dt>
                        <dd class="col-sm-2">
                            <div class="form-check form-check-inline">
                                <input type="radio" id="reasons6" name="reasons6" class="form-check-input" formControlName="reasons6" (change)="updatePrivacyNoticeValue($event)" value="Yes">
                                <label class="form-check-label" for="reasons6">Yes</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="radio" id="reasons6" name="reasons6" class="form-check-input" formControlName="reasons6" (change)="updatePrivacyNoticeValue($event)" value="No">
                                <label class="form-check-label" for="reasons6">No</label>
                            </div>
                        </dd>
                        <dd class="col-sm-2 text-nowrap">Can customers limit this?</dd>
                        <dd class="col-sm-3">
                            <div class="form-check form-check-inline">
                                <input type="radio" id="customerLimit6" name="customerLimit6" class="form-check-input" formControlName="customerLimit6" (change)="updatePrivacyNoticeValue($event)" value="Yes">
                                <label class="form-check-label" for="customerLimit6">Yes</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="radio" id="customerLimit6" name="customerLimit6" class="form-check-input" formControlName="customerLimit6" (change)="updatePrivacyNoticeValue($event)" value="No">
                                <label class="form-check-label" for="customerLimit6">No</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="radio" id="customerLimit6" name="customerLimit6" class="form-check-input" formControlName="customerLimit6" (change)="updatePrivacyNoticeValue($event)" value="We don't share">
                                <label class="form-check-label" for="customerLimit6">We don't share</label>
                            </div>
                        </dd>
                    </dl>
                    <dl class="row mb-0">
                        <dt class="col-sm-5">For our nonaffiliates to market to you</dt>
                        <dd class="col-sm-2">
                            <div class="form-check form-check-inline">
                                <input type="radio" id="reasons7" name="reasons7" class="form-check-input" formControlName="reasons7" (change)="updatePrivacyNoticeValue($event)" value="Yes">
                                <label class="form-check-label" for="customerLimit7">Yes</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="radio" id="reasons7" name="reasons7" class="form-check-input" formControlName="reasons7" (change)="updatePrivacyNoticeValue($event)" value="No">
                                <label class="form-check-label" for="reasons7">No</label>
                            </div>
                        </dd>
                        <dd class="col-sm-2 text-nowrap">Can customers limit this?</dd>
                        <dd class="col-sm-3">
                            <div class="form-check form-check-inline">
                                <input type="radio" id="customerLimit7" name="customerLimit7" class="form-check-input" formControlName="customerLimit7" (change)="updatePrivacyNoticeValue($event)" value="Yes">
                                <label class="form-check-label" for="customerLimit7">Yes</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="radio" id="customerLimit7" name="customerLimit7" class="form-check-input" formControlName="customerLimit7" (change)="updatePrivacyNoticeValue($event)" value="No">
                                <label class="form-check-label" for="customerLimit7">No</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="radio" id="customerLimit7" name="customerLimit7" class="form-check-input" formControlName="customerLimit7" (change)="updatePrivacyNoticeValue($event)" value="We don't share">
                                <label class="form-check-label" for="customerLimit7">We don't share</label>
                            </div>
                        </dd>
                    </dl>
                </section>
                <div class="row">
                    <div class="col-md-5">
                        <section>
                            <h5>To limit your sharing</h5>
                            <p class="row ml-1">Will start reporting after <input class="form-control form-control-sm col-sm-2 mx-2" (change)="updatePrivacyNoticeValue($event)" formControlName="limitSharingDays" name="limitSharingDays">
                                days</p>
                        </section>
                        <section>
                            <h5>Mail-in Form</h5>
                            <dl class="row mb-0">
                                <dt class="col-sm-12">For your own marketing purposes</dt>
                                <dd class="col-sm-12">
                                    <input class="form-control form-control-sm" formControlName="mailInForm" name="mailInForm" (change)="updatePrivacyNoticeValue($event)">
                                </dd>
                            </dl>
                        </section>
                    </div>
                    <div class="col-md-7">
                        <section>
                            <h5>How will you be collecting the customer's information? (Please give 3 examples)</h5>
                            <ol class="mb-0">
                                <li><input class="form-control form-control-sm" formControlName="howInformationCollected1" (change)="updatePrivacyNoticeValue($event)">
                                <li><input class="form-control form-control-sm" formControlName="howInformationCollected2" (change)="updatePrivacyNoticeValue($event)">
                                <li><input class="form-control form-control-sm" formControlName="howInformationCollected3" (change)="updatePrivacyNoticeValue($event)">
                            </ol>
                            Also<textarea class="form-control form-control-sm" formControlName="howInformationCollectedAlso" (change)="updatePrivacyNoticeValue($event)">We also collect your personal information from others such as credit bureaus, affiliates, or other companies.</textarea>
                        </section>
                    </div>
                </div>
            </form>
            }
            @if (itemsOwedForm && itemsOwedForm.enabled) {
            <form [formGroup]="itemsOwedForm">
                <h3>Dealership Items Owes To Buyer</h3>
                <ul class="list-group list-group-flush" formArrayName="weOweItems">
                    @for (weOweItemForm of weOweItems.controls; track weOweItemForm; let i = $index) {
                    <li class="list-group-item">
                        <form [formGroup]="weOweItemForm">
                            <div class="form-row">
                                <div class="col">
                                    <div class="form-group">
                                        @if (i == 0) {
                                        <label>Date Owed</label>
                                        }
                                        <input type="date" [id]="'dealer-dateOwed-' + i" class="form-control form-control-sm" formControlName="dateOwed" placeholder="dateOwed" (change)="updateTable($event, i)" />
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="form-group">
                                        @if (i == 0) {
                                        <label>Item Owed</label>
                                        }
                                        <input type="text" [id]="'dealer-itemOwed-' + i" class="form-control form-control-sm" formControlName="itemOwed" placeholder="Enter description of item owed here..." (change)="updateTable($event, i)" />
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="form-group">
                                        @if (i == 0) {
                                        <label>Date Entered</label>
                                        }
                                        <input type="date" [id]="'dealer-dateEntered-' + i" class="form-control form-control-sm" formControlName="dateEntered" placeholder="dateEntered" (change)="updateTable($event, i)" />
                                    </div>
                                </div>
                            </div>
                        </form>
                    </li>
                    }
                </ul>
                <button class="btn btn-sm btn-primary" (click)="addNew('Buyer')">Add</button>
                <ul class="list-group list-group-flush" formArrayName="youOweItems">
                    <h3>Buyer Items Owes To Dealership</h3>
                    @for (youOweItemForm of youOweItems.controls; track youOweItemForm; let i = $index) {
                    <li class="list-group-item">
                        <form [formGroup]="youOweItemForm">
                            <div class="form-row">
                                <div class="col">
                                    <div class="form-group">
                                        @if (i == 0) {
                                        <label>Date Owed</label>
                                        }
                                        <input type="date" [id]="'buyer-dateOwed-' + i" class="form-control form-control-sm" formControlName="dateOwed" placeholder="dateOwed" (change)="updateTable($event, i)" />
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="form-group">
                                        @if (i == 0) {
                                        <label>Item Owed</label>
                                        }
                                        <input type="text" [id]="'buyer-itemOwed-' + i" class="form-control form-control-sm" formControlName="itemOwed" placeholder="Enter description of item owed here..." (change)="updateTable($event, i)" />
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="form-group">
                                        @if (i == 0) {
                                        <label>Date Entered</label>
                                        }
                                        <input type="date" [id]="'buyer-dateEntered-' + i" class="form-control form-control-sm" formControlName="dateEntered" placeholder="dateEntered" (change)="updateTable($event, i)" />
                                    </div>
                                </div>
                            </div>
                        </form>
                    </li>
                    }
                </ul>
                <button class="btn btn-sm btn-primary" (click)="addNew('Dealer')">Add</button>
            </form>
            }
        </div>
        <div class="modal-footer">
            <button class="btn btn-primary" (click)="saveDefaults()">Save & Close</button>
            <button data-dismiss="modal" class="btn btn-secondary" id="btn-close-dynamicSetupForm">Close</button>
        </div>
    </div>
</div>